import {Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import { permissions } from '../../permissions';
import {WorkspaceService} from '../../views/oes/services/workspace.service'
import {AuthService} from '../../auth/auth.service';
import {ScreenSizeService} from '../../services/screen-size.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';

// Import navigation elements
import { navigation } from '../../_nav';
import {SidebarService} from '../../services/sidebar.service';
import {MOesWorkspaceService} from '../../modules/mobile/services/m-oes-workspace.service';
import {MatExpansionPanel} from '@angular/material';

@Component({
    selector: 'app-sidebar-nav',
    templateUrl: './app-sidebar-nav.component.html',
    styles: [
        `
      .mat-left-expansion-panel-header .mat-expansion-indicator::after {
        color:red;
        transform: rotate(225deg) !important;
      }
      span[style] {
           font-size: 22px !important;
           color: blue !important;
        }
    `
    ],
    providers: [
        WorkspaceService,
        AuthService,
        SidebarService
    ]
})
export class AppSidebarNavComponent implements OnInit, OnDestroy {

    @ViewChild('quickOrderExpansionPanel') quickOrderExpansionPanel: MatExpansionPanel;
    @ViewChild('scansExpansionPanel') scansExpansionPanel: MatExpansionPanel;

    public navigation = navigation;
    public permissions = permissions;
    public inventoryManagementEnabled: boolean;
    public mobileAllowInventoryManagement: boolean;
    public isMobileScreen: boolean;
    private listenMobileWorkspaceService: boolean;
    private screenSizeService: ScreenSizeService;
    private mobileWorkspaceService: MOesWorkspaceService;
    public ePortal = true;
    public sGateway = true;
    public cGateway = true;
    public actions = true;
    public configration = true;
    public links = true;
    public admin = true;


    public isDivider(item) {
        return !!item.divider;
    }

    public isTitle(item) {
        return !!item.title;
    }

    constructor(
        private workspaceService: WorkspaceService,
        private authService: AuthService,
        private router: Router,
        private sidebarService: SidebarService
    ) {
        this.inventoryManagementEnabled = false;
        this.screenSizeService = ScreenSizeService.getInstance();
        this.mobileWorkspaceService = MOesWorkspaceService.getInstance();
        this.mobileAllowInventoryManagement = this.mobileWorkspaceService.allowInventoryManagement;
        this.isMobileScreen = this.screenSizeService.isMobileScreen;
        this.workspaceService.subscribe({
            next: (v) => {
                this.inventoryManagementEnabled = this.workspaceService.CU0_ALLOW_INVENTORY_MANAGEMENT === 1;
            }
        });
        this.router.events.subscribe(() => {
            this.isMobileScreen = this.screenSizeService.isMobileScreen;
        });
    }

    ngOnInit() {
        this.isMobileScreen = this.screenSizeService.isMobileScreen;
        this.mobileAllowInventoryManagement = this.mobileWorkspaceService.allowInventoryManagement;
        this.listenMobileWorkspaceService = true;
        this.listenMobileWorkspace();
    }

    ngOnDestroy() {
        this.listenMobileWorkspaceService = false;
    }

    public menuItemClick() {
        this.collapseExpansionPanels();
        this.closeSideMenu();
        this.router.routeReuseStrategy.shouldReuseRoute = function (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
            return false;
        };
    }

    public supplierGateway(){
        this.sGateway = !this.sGateway;
    }
    public ediPortal(){
        this.ePortal = !this.ePortal;
    }
    public customerGateway(){
        this.cGateway = !this.cGateway;
    }
    public actionsMenu() {
        this.actions = !this.actions;
    }

    public adminMenu() {
        this.admin = !this.admin;
    }

    public configrationMenu(){
        this.configration = !this.configration;
    }
    public linksMenu(){
        this.links = !this.links;
    }

    private listenMobileWorkspace() {
        this.mobileAllowInventoryManagement = this.mobileWorkspaceService.allowInventoryManagement;
        setTimeout(() => {
            if (this.listenMobileWorkspaceService) {
                this.listenMobileWorkspace();
            }
        }, 500);
    }

    private collapseExpansionPanels() {
        if (this.scansExpansionPanel) {
            this.scansExpansionPanel.close();
        }
        if (this.quickOrderExpansionPanel) {
            this.quickOrderExpansionPanel.close();
        }
    }

    closeSideMenu() {
        this.sidebarService.setStatus(false);
    }

    logout() {
        this.closeSideMenu();
        this.authService.logout();
    }
}



@Component({
    selector: 'app-sidebar-nav-item',
    template: `
        <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
            <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
        </li>
        <ng-template #dropdown>
            <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
                [class.open]="isActive()"
                routerLinkActive="open"
                appNavDropdown>
                <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
            </li>
        </ng-template>
    `
})
export class AppSidebarNavItemComponent {
    @Input() item: any;

    public hasClass() {
        return !!this.item.class;
    }

    public isDropdown() {
        return !!this.item.children;
    }

    public thisUrl() {
        return this.item.url
    }

    public isActive() {
        return this.router.isActive(this.thisUrl(), false)
    }

    constructor( private router: Router )  { }

}

@Component({
    selector: 'app-sidebar-nav-link',
    template: `
        <a *ngIf="!isExternalLink(); else external"
           [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
           routerLinkActive="active"
           [routerLink]="[link.url]">
            <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
            {{ link.name }}
            <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
        </a>
        <ng-template #external>
            <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}">
                <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
                {{ link.name }}
                <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
            </a>
        </ng-template>
    `
})
export class AppSidebarNavLinkComponent {
    @Input() link: any;

    public hasVariant() {
        return !!this.link.variant;
    }

    public isBadge() {
        return !!this.link.badge;
    }

    public isExternalLink() {
        return this.link.url.substring(0, 4) === 'http';
    }

    public isIcon() {
        return !!this.link.icon;
    }

    constructor() { }
}

@Component({
    selector: 'app-sidebar-nav-dropdown',
    template: `
        <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
            <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
            {{ link.name }}
            <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
        </a>
        <ul class="nav-dropdown-items">
            <ng-template ngFor let-child [ngForOf]="link.children">
                <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
            </ng-template>
        </ul>
    `
})
export class AppSidebarNavDropdownComponent {
    @Input() link: any;

    public isBadge() {
        return !!this.link.badge;
    }

    public isIcon() {
        return !!this.link.icon;
    }

    constructor() { }
}

@Component({
    selector: 'app-sidebar-nav-title',
    template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
    @Input() title: any;

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnInit() {
        const nativeElement: HTMLElement = this.el.nativeElement;
        const li = this.renderer.createElement('li');
        const name = this.renderer.createText(this.title.name);

        this.renderer.addClass(li, 'nav-title');

        if ( this.title.class ) {
            const classes = this.title.class;
            this.renderer.addClass(li, classes);
        }

        if ( this.title.wrapper ) {
            const wrapper = this.renderer.createElement(this.title.wrapper.element);

            this.renderer.appendChild(wrapper, name);
            this.renderer.appendChild(li, wrapper);
        } else {
            this.renderer.appendChild(li, name);
        }
        this.renderer.appendChild(nativeElement, li);
    }
}

export const APP_SIDEBAR_NAV = [
    AppSidebarNavComponent,
    AppSidebarNavDropdownComponent,
    AppSidebarNavItemComponent,
    AppSidebarNavLinkComponent,
    AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-sidebar-nav/app-sidebar-nav.component.ts